import React from "react";
import { cdnImg } from "../../../Utils/cdnImage";
import RenderOddsHome from "./RenderOddsHome";
import moment from "moment";
import { formatWithCommas } from "../../../Utils/Toast";
import { Link } from "react-router-dom";
import AuthContext from "../../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { isEmpty } from "lodash";

const SingleEvent = ({ res, matchOdds, addToFavioute }) => {
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const matchLimit = useContextSelector(AuthContext, (ctx) => {
    return ctx.matchLimit;
  });
  const blockList = useContextSelector(AuthContext, (ctx) => {
    return ctx.blockList;
  });
  const isBeforeThreeHours = (object) => {
    const now = object?.eventDateTime;
    const threeHoursFromNow = moment(now).subtract(3, "hours").toDate();
    return moment(threeHoursFromNow).isAfter(moment().toDate());
  };
  const getBlockLimit = (object) => {
    return blockList?.length > 0
      ? blockList?.find((item) => {
          return item?.eventId == object?.eventId;
        })
      : {};
  };

  const getMatchLimit = (object) => {
    return matchLimit?.length > 0
      ? matchLimit?.find((item) => {
          return (
            item?.betfairId == object?.eventType && item?.market == "Match Odds"
          );
        })
      : {};
  };

  let limitCustomInplay = isEmpty(profileData?.limitCustomInplay)
    ? {
        cricket: 20000,
        soccer: 50000,
        tennis: 50000,
      }
    : profileData?.limitCustomInplay;

  const showSeriesOdds =
    profileData?.seriesBlockList?.length > 0
      ? profileData?.seriesBlockList?.find(
          (item) => item?.seriesId == res?.seriesId,
        )?.matchOdds == "on" || true
      : true;

  let limitBlock = getBlockLimit(res);
  let limitList = getMatchLimit(res);
  let show =
    res?.runners?.length > 0 &&
    res?.hasMatchOdds &&
    showSeriesOdds &&
    (!isEmpty(limitBlock) ? limitBlock?.matchOdds == "on" : true) &&
    (res?.status == "in_play"
      ? matchOdds?.totalMatched > limitCustomInplay[res?.gameType]
      : res?.gameType == "cricket"
        ? matchOdds?.totalMatched > 100000
        : false) &&
    !isEmpty(matchOdds) &&
    (!isEmpty(profileData) && profileData?.minMatchingAmount > 0
      ? matchOdds?.totalMatched > profileData?.minMatchingAmount
      : true);
  let outerCondition =
    isBeforeThreeHours(res) ||
    matchOdds?.ms != 1 ||
    (!isEmpty(limitList) && matchOdds?.totalMatched < limitList?.limit);
  return (
    <dl
      id="highLightEvent_34917695"
      className="game-list-col "
      // disabled
      style={{ display: "flex" }}
    >
      <dt id="eventInfo" style={{ cursor: "pointer" }}>
        <img
          id="playIcon"
          className={res?.status == "in_play" ? "icon-in_play" : "icon-no_play"}
          src={cdnImg("/assets/images/transparent.gif")}
        />
        <Link
          to={`/match-detail-sky/${res?.eventId}/${res?.marketId}`}
          id="vsName"
        >
          {res?.eventName?.split(" v ")[0]}{" "}
          <strong style={isEmpty(res?.outcome) ? {} : { color: "#ffa10c" }}>
            {isEmpty(res?.outcome) ? "v" : res?.outcome}
          </strong>{" "}
          {res?.eventName?.split(" v ")[1]}
        </Link>
        <span id="dateTimeInfo" className="game-list-time">
          {res?.status == "in_play" ? (
            <span className="in_play">In-Play</span>
          ) : (
            `${
              isDateToday(res?.eventDateTime)
                ? "Today"
                : moment(res?.eventDateTime).format("DD/MM")
            } ${moment(res?.eventDateTime).format("HH:MM")}`
          )}
        </span>{" "}
        {res?.status == "in_play" && (
          <span
            className="game-live"
            id="streamingIcon"
            style={{
              display: "inline-flex",
              marginRight: "4px",
            }}
          >
            Live
          </span>
        )}
        {res?.hasFancy && (
          <span
            className="game-fancy in-play"
            id="fancyBetIcon"
            style={{
              cursor: "pointer",
              display: "inline-flex",
              marginRight: "4px",
            }}
          >
            Fancy
          </span>
        )}
        {res?.hasBookmaker && (
          <span
            className="game-bookmaker"
            id="bookMakerIcon"
            style={{ cursor: "pointer", marginRight: "4px" }}
          >
            BookMaker
          </span>
        )}
        {res?.hasSportBook && (
          <span
            className="game-sportsbook"
            id="feedingSiteIcon"
            style={{ marginRight: "4px" }}
          >
            Sportsbook
          </span>
        )}
      </dt>
      <dd id="matched" className="col-matched">
        USD {formatWithCommas(res?.totalMatched)}
      </dd>
      {show ? (
        <RenderOddsHome
          outerCondition={outerCondition}
          res={res}
          matchOdds={matchOdds}
        />
      ) : (
        <>
          <dd className={`col-visit disabled`}>
            <a className="btn-back">-</a>
            <a className="btn-lay">-</a>
          </dd>
          <dd className={`col-draw disabled`}>
            <a className="btn-back">-</a>
            <a className="btn-lay">-</a>
          </dd>
          <dd className={`col-home disabled`}>
            <a className="btn-back">-</a>
            <a className="btn-lay">-</a>
          </dd>
        </>
      )}

      <dd
        onClick={(e) => {
          if (res?.runners?.length > 0) {
            e.preventDefault();
            e.stopPropagation();
            addToFavioute(
              res?.eventId,
              "Match Odds",
              res?.marketId,
              res?.eventType,
              "Match Odds",
            );
          }
        }}
        className="col-info"
      >
        <a
          id="multiMarketPin"
          className="add-pin"
          style={{ cursor: "pointer" }}
          title="Add to Multi Markets"
        >
          Pin
        </a>
      </dd>
    </dl>
  );
};

export default SingleEvent;
